export class TestError extends Error {
    public readonly name = 'TestError';
    public constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, TestError.prototype);
    }
}
